module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-3-80198500e91247dc5945e50a21abfb66.png";